// extracted by mini-css-extract-plugin
module.exports = {"title":"_1xnkLaLfp7-mP00PJx3IQK","btn":"_1sbLNCMbY3R18F8GypvdSw"};